/* eslint-disable-next-line no-restricted-imports */
import { type TextFieldVariants } from '@mui/material/TextField';

/* eslint-disable-next-line no-restricted-imports */
export { type SelectChangeEvent } from '@mui/material/Select';

export type TextFieldVariant = TextFieldVariants;

export enum CheckboxState {
  Indeterminate = 'Indeterminate',
  NotSelected = 'NotSelected',
  Selected = 'Selected',
}

export const CheckboxStateActionLabels: Record<CheckboxState, string> = {
  [CheckboxState.Indeterminate]: 'Select All',
  [CheckboxState.NotSelected]: 'Select All',
  [CheckboxState.Selected]: 'Clear All',
};
